import angular from 'angular';

import routing from './download.routes';
import DownloadCtrl from './download.controller';
import AnalyticsServ from '../../services/analytics';

import HeaderNav from '../../directives/header-nav';
import LwPageFooter from '../../directives/lw-page-footer';

export default angular.module('app.download', [HeaderNav, LwPageFooter, AnalyticsServ])
	.config(routing)
	.controller('DownloadCtrl', DownloadCtrl)
	.name;



// WEBPACK FOOTER //
// ./project/pages/download/index.js